import { Text } from '../../..'
import Format from '../../Format'
import { CarouselListing } from '../../../../types/listings'
import { defineMessages, useIntl } from 'react-intl'
import { useViewListingShowPageUrl } from '../../../../hooks/listings'
import { PocketAmountAndMortgageDiff } from './PocketAmountAndMortgageDiff'
import { HomebotListingsButton } from '../../../buyers/Button/HomebotListingsButton/HomebotListingsButton'
import baseStyles from '../ListingsCarousel.module.scss'
import styles from './ListingsCarouselSlide.module.scss'
import { formatCurrency } from '../../../../helpers/formatters'
import { sqftToAcres } from '../../../../helpers/converters'
import { isLandPropertyType } from '../../../../helpers/listings'

export const MSG = defineMessages({
  bed: {
    id: 'MarketSpotLight.equitySmartSearch.bed',
    defaultMessage: '{bed} bd'
  },
  bath: {
    id: 'MarketSpotLight.equitySmartSearch.bath',
    defaultMessage: '{bath} ba'
  },
  sqft: {
    id: 'MarketSpotLight.equitySmartSearch.sqft',
    defaultMessage: '{sqft} ft²'
  },
  acres: {
    id: 'MarketSpotLight.equitySmartSearch.acres',
    defaultMessage: '{acres} acres'
  }
})

export interface ListingsCarouselSlideProps {
  listing: CarouselListing
}

export const ListingsCarouselSlide = ({ listing }: ListingsCarouselSlideProps) => {
  const intl = useIntl()
  const listingUrl = useViewListingShowPageUrl(listing)
  const propertyIsLand = isLandPropertyType(listing.propertyType)

  return (
    <HomebotListingsButton key={listing.id} listingsUrl={listingUrl} className={baseStyles.buttonParent}>
      <div className={styles.listingImageContainer} style={{ backgroundImage: `url(${listing.thumbnailImage})` }} />
      <div className={styles.listingDataContainer}>
        <div className={styles.listingPriceTextRow}>
          <Text size='xl' weight='bold' variantCount='900' variant='neutralCool'>
            {formatCurrency(listing.listPrice)}
          </Text>
        </div>
        <div>
          <div className={styles.bedBathSqftTextRow}>
            {listing.bedroomsCount !== null && (
              <Text variantCount='700' variant='neutralCool' className={styles.bedBathSqft}>
                {intl.formatMessage(MSG.bed, { bed: listing.bedroomsCount })}
              </Text>
            )}
            {listing.bathroomsCount !== null && (
              <Text variantCount='700' variant='neutralCool' className={styles.bedBathSqft}>
                {intl.formatMessage(MSG.bath, { bath: listing.bathroomsCount })}
              </Text>
            )}
            {!propertyIsLand && listing.sqftBuilding !== null && (
              <Text variantCount='700' variant='neutralCool' className={styles.bedBathSqft}>
                {intl.formatMessage(MSG.sqft, {
                  sqft: Format.number(listing.sqftBuilding)
                })}
              </Text>
            )}
            {propertyIsLand && listing?.sqftLot !== null && (
              <Text variantCount='700' variant='neutralCool' className={styles.bedBathSqft}>
                {intl.formatMessage(MSG.acres, {
                  acres: sqftToAcres(listing.sqftLot).toFixed(2)
                })}
              </Text>
            )}
          </div>
          {/* todo - reasses whether we can kill this */}
          {/* {listing.pocketAmount && listing.mortgagePaymentDifference && (
            <PocketAmountAndMortgageDiff
              pocketAmount={listing.pocketAmount}
              mortgagePaymentDifference={listing.mortgagePaymentDifference}
            />
          )} */}
        </div>
      </div>
    </HomebotListingsButton>
  )
}
